<template>
    <Modal class-name="scrollable vertical-center-modal" title="Nuevo indicador" v-model="show" :footer-hide="true" :scrollable="true">
        <Form style="width: 100%" ref="planForm" :model="indicator" :rules="ruleInline">
            <Row :gutter="16">
                <i-col span="24">
                    <FormItem label="Indicador" prop="name">
                        <Input type="textarea" :autosize="{minRows: 5,maxRows: 8}" v-model="indicator.name" placeholder="Indicador"/>
                    </FormItem>
                </i-col>
                <i-col span="24">
                    <Button style="margin-top: 25px" size="large" long type="primary" :loading="loading" @click="save">Agregar</Button>
                </i-col>
            </Row>
        </Form>
    </Modal>
</template>

<script>
    export default {
        data(){
            return {
                show: false,
                type: '',
                indicator: {
                    name: ""
                },
                result: null,
                loading: false,
                ruleInline: {
                    name: [
                        { required: true, message: 'Indicador es requerido', trigger: 'change' }
                    ],
                },
            }
        },
        methods: {
            save(){
                this.$refs.planForm.validate(valid => {

                    if(valid){
                        this.loading = true
                        window.axios.post(this.$root.API_URL + `/indicators/${this.result.id}/create`, { type: this.type, ...this.indicator, })
                        .then(response => {
                            if(response.data.success){
                                window.EventBus.$emit(`result-item-${this.result.id}--add-indicator`, response.data.indicator)
                                this.show = false
                                this.loading = false
                                this.clear()
                            }
                        })
                        .catch(() => {
                            this.loading = false
                            this.$Message.error('Hubo un problema, no pudimos completar esta acción');
                        })
                    }
                })
            },
            clear(){
                this.indicator = {
                    text: ""
                }
                this.type = ''
                this.result = null
            }
        },
        mounted(){
            window.EventBus.$on('program-poa--create-indicator', (result, type) => {
                this.type = type
                this.result = result
                this.show = true
            })
        }
    }
</script>